import type { TriggerKind } from '../TriggerNotesCard';

// Mirrors the backend decision validators: trimmed reason, 1-5000 chars.
export const GO_AHEAD_REASON_MIN_LENGTH = 1;
export const GO_AHEAD_REASON_MAX_LENGTH = 5000;

export interface GoAheadChoice {
    action: string;
    label: string;
    // Null: no reason is asked and the choice fires straight away.
    consequence: string | null;
}

// The orthodontist's three choices; retention starts with no retainer order (ODO sets it at Ret-3).
export const GO_AHEAD_CHOICES: Readonly<Record<TriggerKind, readonly GoAheadChoice[]>> = {
    refinement: [
        { action: 'review-approve-refinement', label: 'Approve refinement', consequence: null },
        {
            action: 'refuse-refinement-continue',
            label: 'Continue treatment',
            consequence: 'The refinement is declined and the patient stays in active treatment.'
        },
        {
            action: 'end-treatment-start-retention',
            label: 'Start retention',
            consequence:
                'Active treatment ends and the case moves to retention. The retainer order is set later, before it is placed.'
        }
    ],
    retention: [
        { action: 'approve-retention', label: 'Start retention', consequence: null },
        {
            action: 'refuse-retention-continue',
            label: 'Continue treatment',
            consequence: 'Retention is declined and the patient stays in active treatment.'
        },
        {
            action: 'start-refinement-from-retention',
            label: 'Start a refinement',
            consequence: 'Retention is set aside and the case moves to refinement records.'
        }
    ]
};

export function isValidGoAheadReason(text: string): boolean {
    const length = text.trim().length;
    return length >= GO_AHEAD_REASON_MIN_LENGTH && length <= GO_AHEAD_REASON_MAX_LENGTH;
}

export function goAheadPayload(choice: GoAheadChoice, reason: string): Record<string, unknown> {
    return choice.consequence === null ? {} : { reason: reason.trim() };
}
